import React from "react";
import { useNavigate } from "react-router-dom";
import { CurrencyInr, Buildings, Storefront, ArrowRight } from "@phosphor-icons/react";

function Choice({ icon, title, sub, onClick, testId, tone }) {
  return (
    <button type="button" onClick={onClick} data-testid={testId}
      className={`group w-full text-left rounded-md border bg-slate-900 p-6 flex items-center gap-5 transition-[transform,box-shadow,border-color] duration-200 hover:-translate-y-0.5 hover:shadow-lg ${tone}`}>
      <div className="h-14 w-14 shrink-0 grid place-items-center rounded-sm bg-red-600 text-white">{icon}</div>
      <div className="flex-1">
        <div className="font-heading font-black text-2xl tracking-tight text-white">{title}</div>
        <div className="text-sm text-slate-300 mt-1">{sub}</div>
      </div>
      <ArrowRight size={22} weight="bold" className="text-zinc-400 transition-transform duration-200 group-hover:translate-x-1 group-hover:text-white" />
    </button>
  );
}

export default function Landing() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-zinc-50 relative overflow-hidden" data-testid="landing-page">
      <div className="absolute inset-0 bg-grid opacity-60" />
      <div className="relative max-w-3xl mx-auto px-6 sm:px-10 py-14 lg:py-24">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 grid place-items-center rounded-sm bg-gradient-to-br from-red-500 to-red-700 shadow-[0_0_18px_rgba(239,68,68,0.45)]">
            <CurrencyInr size={22} weight="bold" className="text-white" />
          </div>
          <div>
            <div className="font-heading font-black text-lg leading-none tracking-tight brand-gradient">RECONIK</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 mt-1">Mr. Chow's Finance Control Room</div>
          </div>
        </div>

        <h1 className="mt-16 lg:mt-24 font-heading font-black tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-zinc-900">
          Where are you<br /><span className="text-blue-600">signing in from?</span>
        </h1>

        <div className="mt-12 grid gap-4">
          <Choice icon={<Buildings size={28} weight="duotone" />} title="Head Office"
            sub="Finance dashboard: approvals, cash health, reports. Registered emails only."
            onClick={() => navigate("/login")} testId="landing-head-office-btn" tone="border-zinc-200 hover:border-blue-500" />
          <Choice icon={<Storefront size={28} weight="duotone" />} title="Willingdon"
            sub="Outlet: snap an order slip and save it."
            onClick={() => navigate("/willingdon")} testId="landing-willingdon-btn" tone="border-zinc-200 hover:border-red-500" />
        </div>
      </div>
    </div>
  );
}
